import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

export const Spinner = ({ size, color }) =>
  <CircularProgress size={size || 40} sx={{ marginTop: '10px', color: color || '#004680' }} />
